import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Clock, Sparkle, ArrowRight } from "@phosphor-icons/react";
import { HeroSlider } from "../components/HeroSlider";
import { useLang } from "../context/LanguageContext";
import { Reveal } from "../components/Reveal";

const HL_ICONS = [ShieldCheck, Clock, Sparkle];

export default function Home() {
  const { t } = useLang();
  const navigate = useNavigate();
  const items = t.services.items;

  return (
    <div className="bg-ink-900">
      <HeroSlider />

      {/* Services highlights (white / luxury) */}
      <section className="cfg relative py-16 md:py-24 bg-white" data-testid="home-highlights">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {items.map((it, i) => {
              const Icon = HL_ICONS[i];
              return (
                <Reveal key={i} delay={i * 0.1} y={40}>
                  <div className="group h-full rounded-[24px] border border-[#071B2F]/10 bg-white p-8 hover:border-[#D4AF37]/50 shadow-[0_20px_50px_-35px_rgba(7,27,47,0.35)] transition-colors">
                    <Icon weight="light" size={34} className="text-[#D4AF37] group-hover:scale-110 transition-transform" />
                    <h3 className="font-bookman font-bold text-2xl text-[#071B2F] mt-5 mb-2">{it.title}</h3>
                    <p className="cfg-body text-[#071B2F]/55 text-sm">{it.desc}</p>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA band (dark) */}
      <section className="relative py-20 md:py-28 bg-ink-950 grain overflow-hidden" data-testid="home-cta">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 text-center">
          <Reveal>
            <p className="overline text-xs text-gold mb-5">{t.pages.fleetLabel}</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl md:text-6xl text-white tracking-tight max-w-3xl mx-auto">
              {t.hero.line1} {t.hero.line2} <span className="italic text-gold">{t.hero.line3}</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => navigate("/vehicules")} data-testid="home-cta-book" className="group inline-flex items-center justify-center gap-3 bg-gold hover:bg-gold-champagne text-black overline text-xs px-8 py-4 transition-colors">
                {t.pages.bookCta}<ArrowRight weight="light" size={18} className="group-hover:translate-x-1 transition-transform" />
              </button>
              <button onClick={() => navigate("/offres")} data-testid="home-cta-offers" className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-gold text-white overline text-xs px-8 py-4 transition-colors">
                {t.nav.offers}
              </button>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
